import React, { useState } from "react";
import PropTypes from "prop-types";
import Image from "next/image";
import setLanguage from "next-translate/setLanguage";
import { useRouter } from "next/router";
import { Button, Menu, MenuItem, Typography, Stack } from "@mui/material";
import dayjs from "dayjs";
import "dayjs/locale/tr";

const onLanguageChange = async (language: any) => {
  await setLanguage(language);
  dayjs.locale(language);
};

export function LocaleToggle({ textColor = "white" }) {
  const { locale } = useRouter();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{ p: 0, justifyContent: "flex-end" }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Image
            src={`/images/flags/${locale}-flag.png`}
            alt={`${locale} flag`}
            width="25"
            height="25"
          />
          <Typography variant="body2" color={textColor} sx={{ textTransform: "uppercase" }}>
            {locale}
          </Typography>
        </Stack>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={() => {
            onLanguageChange("tr");
            handleClose();
          }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <Image src="/images/flags/tr-flag.png" alt="tr flag" width="25" height="25" />
            <Typography variant="body2" color="text.secondary">
              Türkçe
            </Typography>
          </Stack>
        </MenuItem>
        <MenuItem
          onClick={() => {
            onLanguageChange("en");
            handleClose();
          }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <Image src="/images/flags/en-flag.png" alt="en flag" width="25" height="25" />
            <Typography variant="body2" color="text.secondary">
              English
            </Typography>
          </Stack>
        </MenuItem>
      </Menu>
    </>
  );
}

LocaleToggle.propTypes = {
  textColor: PropTypes.string,
};
